import defaultCardImg from '../../assets/common/debit/default-card.png'
import debitCardLogo from '../../assets/image/top-credit/debit-card-logo.png'
import cardIntroApply from '../../assets/image/top-credit/introduce/card-intro-apply.png'
import cardIntroDisplay from '../../assets/image/top-credit/introduce/card-intro-display.png'
import cardIntroPos from '../../assets/image/top-credit/introduce/card-intro-pos.png'
import cardIntroVip from '../../assets/image/top-credit/introduce/card-intro-vip.png'

export const debitCard = {
  defaultCardImg: defaultCardImg,
  debitCardLogo: debitCardLogo,
  cardRadius: '12px',
  simpleLogo: debitCardLogo,
  introduceImgs: {
    cardIntroApply,
    cardIntroDisplay,
    cardIntroPos,
    cardIntroVip,
  },
} as PlatformConfig['debitCard']
